module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/r3leve_barre-cb9942f2b70d693381bdcaab7d68f351.png";